// frontend/src/pages/teacher/EnrollStudentModal.jsx

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaSpinner, FaUserGraduate, FaBookOpen, FaPlusCircle } from 'react-icons/fa';
import { API_BASE_URL, getAuthHeaders } from '../../modules/api';

const EnrollStudentModal = ({ isOpen, onClose, onStudentEnrolled }) => {
    const [formData, setFormData] = useState({
        student_username: '',
        course_id: '',
    });
    const [courses, setCourses] = useState([]);
    const [uiState, setUiState] = useState({
        isLoading: false,
        isFetchingCourses: true,
        error: null,
        success: null,
    });

    // --- 1. دریافت لیست دوره‌های معلم ---
    useEffect(() => {
        if (!isOpen) return;

        const fetchCourses = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/core/courses/`, getAuthHeaders());
                setCourses(response.data);
                if (response.data.length > 0) {
                    setFormData(prev => ({ ...prev, course_id: response.data[0].id }));
                } else {
                    setUiState(prev => ({ ...prev, error: 'شما هیچ دوره‌ای برای ثبت‌نام دانش‌آموز ندارید.' }));
                }
            } catch (err) {
                setUiState(prev => ({ ...prev, error: 'خطا در دریافت دوره‌ها.' }));
                console.error(err);
            } finally {
                setUiState(prev => ({ ...prev, isFetchingCourses: false }));
            }
        };

        fetchCourses();
    }, [isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // --- 2. ثبت‌نام دانش‌آموز ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        setUiState(prev => ({ ...prev, isLoading: true, error: null, success: null }));

        // ارسال داده به API جدید EnrollStudentAPIView
        const payload = {
            student_username: formData.student_username,
            course_id: formData.course_id 
        };

        try {
            const response = await axios.post(`${API_BASE_URL}/core/enroll-student/`, payload, getAuthHeaders());
            
            setUiState(prev => ({ 
                ...prev, 
                success: response.data.detail || 'دانش‌آموز با موفقیت اضافه شد.'
            }));
            
            // فراخوانی تابع والد برای رفرش لیست
            onStudentEnrolled(); 

            // بستن مودال پس از موفقیت
            setTimeout(onClose, 2000); 

        } catch (err) {
            const errorMessage = err.response?.data?.detail || 'خطا در ثبت‌نام. مطمئن شوید دانش‌آموز وجود دارد.';
            setUiState(prev => ({ ...prev, error: errorMessage }));
            console.error(err);
        } finally {
            setUiState(prev => ({ ...prev, isLoading: false }));
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2><FaPlusCircle className="inline-block ml-2" /> افزودن دانش‌آموز به کلاس</h2>
                    <button onClick={onClose} className="modal-close-btn">&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        {uiState.error && <div className="alert alert-danger">{uiState.error}</div>}
                        {uiState.success && <div className="alert alert-success">{uiState.success}</div>}

                        {/* انتخاب دوره */}
                        <div className="form-group">
                            <label><FaBookOpen /> دوره/کلاس مورد نظر</label>
                            <select 
                                name="course_id" 
                                value={formData.course_id} 
                                onChange={handleChange} 
                                required
                                disabled={uiState.isFetchingCourses || uiState.isLoading}
                            >
                                {uiState.isFetchingCourses && <option>در حال بارگذاری...</option>}
                                {!uiState.isFetchingCourses && courses.length === 0 && <option>شما هیچ دوره‌ای ندارید.</option>}
                                {courses.map(course => (
                                    <option key={course.id} value={course.id}>
                                        {course.title} (پایه: {course.grade})
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* کد ملی دانش‌آموز */}
                        <div className="form-group">
                            <label><FaUserGraduate /> نام کاربری دانش‌آموز (کد ملی)</label>
                            <input 
                                type="text" 
                                name="student_username" 
                                placeholder="مثال: 0012345678"
                                value={formData.student_username} 
                                onChange={handleChange} 
                                required
                                disabled={uiState.isLoading}
                            />
                        </div>

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="button button-secondary" onClick={onClose} disabled={uiState.isLoading}>
                            انصراف
                        </button>
                        <button 
                            type="submit" 
                            className="button button-primary" 
                            disabled={uiState.isLoading || courses.length === 0}
                        >
                            {uiState.isLoading ? <FaSpinner className="spinner" /> : 'ثبت نام دانش‌آموز'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EnrollStudentModal;